import { render, staticRenderFns } from "./ResultsSuccessPillars.vue?vue&type=template&id=56ecd4a2&"
import script from "./ResultsSuccessPillars.vue?vue&type=script&lang=js&"
export * from "./ResultsSuccessPillars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports